import Security from './2024';

export default Security;
